import type { FunctionComponent } from "react";

import { useParams } from "react-router-dom";
import CampaignPostSearchAdminPartial from "../../../partials/admin/home/campaign-posts/campaign-post-search.admin.partials";

export const CampaignPostSearchAdminScreen: FunctionComponent = () => {
	const { campaignId } = useParams();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	return <CampaignPostSearchAdminPartial />;
};
